import type { ResponseError } from '@rtkwlf/rendall';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

import { useOrganizationContext } from '@packages/legacy/organization-context';
import { useFeatureFlag } from '@packages/platform/feature-flags/use-feature-flag';

import type { GetRisksParams } from '../queries/use-risks';
import { useRiskExportsMockApi } from '../use-risk-exports-mock';

export interface RiskExportRequest {
  ids: Array<string>;
  queryString: GetRisksParams;
  columnNames: Record<string, string>;
}

export interface RiskExportResponse {
  downloadURL: string;
}

export const useRiskExports = (
  options?: Omit<
    UseMutationOptions<
      RiskExportResponse,
      ResponseError,
      RiskExportRequest,
      unknown
    >,
    'mutationFn'
  >,
) => {
  const [testDataFF] = useFeatureFlag('RISK_IN_UP_LIVE_TEST_DATA');
  const { id } = useOrganizationContext().selectedOrganization;
  const { mockRiskExportApi } = useRiskExportsMockApi();

  return useMutation({
    mutationFn: async (params: RiskExportRequest) => {
      const orgUUID = testDataFF ? 'c8923d83-d419-4453-b768-3e1fbd6d16c2' : id;
      return await mockRiskExportApi(
        `/organizations/${orgUUID}/exports/risks/`,
        params,
      );
    },
    ...options,
  });
};
